import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const reorderRoles = (resource, id, { lotId, levelStructureId, roleIds }) => {
  return axios.put(`/api/${resource}/${id}/setup/lots/${lotId}/roles/order`, {
    level_structure_id: levelStructureId,
    role_ids: roleIds,
  });
};

export const useReorderRoles = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => reorderRoles(resource, id, values),
    onSuccess: () => {
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
